import { useContext } from 'react';
import CurrentDeviceContext from '../context/CurrentDeviceContext';

const useCurrentDeviceId = () => useContext(CurrentDeviceContext);

export default useCurrentDeviceId;
